import React from 'react';
import PropTypes from 'prop-types';

import './NotFoundPage.css';

class notFoundPage extends React.Component {
  render() {
    const { errorText, errorCaption } = this.props;
    return (
      <div id="notFoundPage">
        <h2 className="errorCaption">{errorCaption}</h2>
        <div className="errorText">{errorText}</div>
      </div>
    );
  }
}

notFoundPage.propTypes = {
  errorCaption: PropTypes.string.isRequired,
  errorText: PropTypes.string.isRequired,
};

export default notFoundPage;
